<template>
<form class="form-horizontal" role="form">
  <div class="row">
      <div class="col-md-3"></div>
      <div class="col-md-6">
          <h2>Anmeldung</h2>
          <hr>
      </div>
  </div>

  <div class="row" v-if="login_msg">
    <div class="offset-md-3 col-md-6">
      <div class="alert alert-danger" role="alert" >
        {{login_msg}}
      </div>
    </div>
  </div>

  <div class="row">
      <div class="col-md-3"></div>
      <div class="col-md-6">
          <div class="form-group has-danger">
              <label class="sr-only" for="email">KundenNr</label>
              <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                  <div class="input-group-addon" style="width: 2.6rem"><i class="fa fa-at"></i></div>
                  <input type="text" name="user_number" class="form-control" id="user_number"
                          placeholder="KundenNr" required autofocus v-model="input.usernumber">
              </div>
          </div>
      </div>
  </div>
  <div class="row">
      <div class="col-md-3"></div>
      <div class="col-md-6">
          <div class="form-group">
              <label class="sr-only" for="password">Password</label>
              <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                  <div class="input-group-addon" style="width: 2.6rem"><i class="fa fa-key"></i></div>
                  <input type="password" name="password" class="form-control" id="password"
                          placeholder="Password" required v-model="input.password"
                          v-on:keyup.enter="doLogin">
              </div>
          </div>
      </div>
      <div class="col-md-3">
          <div class="form-control-feedback">
              <span class="text-danger align-middle">
              </span>
          </div>
      </div>
  </div>
  <div class="row" style="padding-top: 1rem">
      <div class="col-md-3"></div>
      <div class="col-md-6">
          <a v-on:click="doLogin" class="btn btn-success"><i class="fa fa-sign-in"></i> Login</a>
      </div>
  </div>
</form>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Login',
  data: function () {
    return {input: {usernumber: '', password: ''}, login_msg: ''}
  },
  methods: {
    doLogin: function () {
      // this.login_msg = null

      var postParams = {user_number: this.input.usernumber, password: this.input.password}
      axios
        .post(process.env.API_HOST + '/api/auth/login', postParams)
        .then(response => {
          if (response.status === 200) {
            localStorage.setItem('API_TOKEN', response.data.api_token)

            this.$emit('authenticated', true)
            this.$store.commit('set_api_key',response.data.api_token)
            this.$router.replace({ path: '/' })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue